import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/src/locale/fr.ts';

// Helpers
import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken3, // #E53935
    secondary: colors.teal, // #FFCDD2
    accent: colors.indigo.base, // #3F51B5
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
});
